const ITEMS = [
  "20 ans d'excellence",
  "Artisans en Normandie",
  "Charpente",
  "Couverture",
  "Bardage",
  "Devis gratuit",
  "L'assurance d'un projet réussi",
  "Isolation RGE",
];

export default function Marquee() {
  const content = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="py-10 border-y border-white/10 overflow-hidden bg-[#0C0C0E]" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {content.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-black uppercase tracking-tight text-5xl md:text-7xl text-outline px-8">
                  {item}
                </span>
                <span className={`w-2.5 h-2.5 ${i % 2 === 0 ? "bg-jaune" : "bg-vert"} rotate-45 shrink-0`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
